import React, { useState } from "react";

const SidebarRelatedPosts = ({ posts, featuredPosts }) => {
  const [activeTab, setActiveTab] = useState("related");

  // Function to format the date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', options);
  };

  // Function to render posts
  const renderPosts = (posts) => {
    return posts.map((post, index) => (
      <div key={index} className="td_module_8 td_module_8_evpn td_module_wrap mb-4">
        <div className="item-details">
          <div className="td-module-meta-info md text-sm text-gray-500 mb-2 grid grid-cols-3 gap-4">
            <span className="td-post-author-name">
              <a
                href={post.authorLink}
                className="text-gray-700 hover:text-green-600"
              >
                {post.author}
              </a>
            </span>
            <span className="td-post-date text-center">
              <time
                className="entry-date updated td-module-date"
                datetime={post.date}
              >
                {formatDate(post.date)} {/* Format the date */}
              </time>
            </span>
            <div className="td-module-readtime text-right">
              {post.readMins} mins {/* Display read time in minutes */}
            </div>
          </div>
          <div className="module-8-title flex flex-col sm:flex-row sm:space-x-4 mt-4">
            <div className="td-module-image small-set-thumnail mb-4 sm:mb-0 flex-shrink-0">
              <div className="td-module-thumb">
                <a
                  href={post.link}
                  rel="bookmark"
                  className="td-image-wrap"
                  title={post.title}
                >
                  <img
                    className="entry-thumb w-32 h-auto max-w-xs sm:max-w-sm md:max-w-md rounded-md object-cover"
                    src={post?.featuredImage ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}` : "/placeholder.jpg"}                    alt={post.title}
                    title={post.title}
                  />
                </a>
              </div>
            </div>
            <div className="td-module-text">
              <a
                href={post.link}
                className="text-lg font-semibold text-gray-800 hover:text-green-600"
              >
                {post.title}
              </a>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="related-posts-container sidebar-related-posts bg-white p-4 shadow-lg rounded-md">
      <div className="td-related-title mb-4">
        <ul className="flex space-x-4 border-b-2 border-gray-200">
          <li
            className={`cur-tab-item ${
              activeTab === "related"
                ? "text-green-600 border-b-2 border-green-600"
                : "text-gray-700"
            }`}
            onClick={() => setActiveTab("related")}
          >
            <a href="#" className="td-cur-simple-item">
              Related posts
            </a>
          </li>
          <li
            className={`${
              activeTab === "featured"
                ? "text-green-600 border-b-2 border-green-600"
                : "text-gray-700"
            }`}
            onClick={() => setActiveTab("featured")}
          >
            <a href="#" className="td-cur-simple-item">
              Featured Posts
            </a>
          </li>
        </ul>
      </div>

      <div id="related-posts-sidebar" className="posts-switch">
        {activeTab === "related" ? renderPosts(posts) : renderPosts(featuredPosts)}
      </div>
    </div>
  );
};

export default SidebarRelatedPosts;
